import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Card from 'components/CncUI/Card';
import Typography from 'components/CncUI/Typography';

const useStyles = makeStyles(({ palette }) => ({
  root: {
    marginTop: 24,
  },
  dataHeader: {
    textAlign: 'center',
    marginBottom: 0,
  },
  data: {
    width: '100%',
    maxWidth: 320,
  },
  dataLabel: {
    textAlign: 'right',
    paddingRight: 10,
    width: '50%',
    alignSelf: 'center',
  },
  dataValue: {
    textAlign: 'left',
    paddingLeft: 10,
    width: '50%',
  },
  green: {
    color: palette.cncUI.default.primary,
  },
}));

const InfoBox = props => {
  const classes = useStyles();
  const { title, data } = props;

  if (!data || data.length === 0) {
    return null;
  }

  return (
    <Grid item xs={12} className={classes.root}>
      <Card id={`Details${title.replace(/\s/g, '')}`}>
        <Card.Title align="center">{title}</Card.Title>
        <Card.Content>
          <Grid container spacing={2} justify="center">
            {data.map((details, i) => (
              <Grid item className={classes.data} key={`ccpa-data-${i}`}>
                <Grid container spacing={2}>
                  {details.title && (
                    <Grid item xs={12}>
                      <Typography variant="h5" className={classes.dataHeader}>
                        {details.title}
                      </Typography>
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    <table className={classes.data}>
                      <tbody>
                        {details.data.map(([label, value], j) => (
                          <tr key={`ccpa-data-item-${j}`}>
                            <th className={classes.dataLabel}>
                              <Typography
                                body1
                                short
                                noMargin
                                component="span"
                                className={classes.green}
                              >
                                {label}
                              </Typography>
                            </th>
                            <td className={classes.dataValue}>
                              <Typography body2 short noMargin component="span">
                                {value}
                              </Typography>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </Grid>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Card.Content>
      </Card>
    </Grid>
  );
};

export default InfoBox;
